import { AbstractMap3sqd8xvg0030s as AbstractMap } from './AbstractMap.mjs';
import {
  HashMapKeysDefaultd8xopyn6vbgh as HashMapKeysDefault,
  HashMapValuesDefault3j1xghpfb6bpq as HashMapValuesDefault,
} from './HashMapEntryDefault.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractMutableMapClass;
function AbstractMutableMap() {
  if (AbstractMutableMapClass === VOID) {
    class $ extends AbstractMap() {
      static new_kotlin_collections_AbstractMutableMap_wd9kkp_k$() {
        var $this = this.new_kotlin_collections_AbstractMap_5v98o7_k$();
        $this.keysView_1 = null;
        $this.valuesView_1 = null;
        return $this;
      }
      createKeysView_aa1bmb_k$() {
        return HashMapKeysDefault().new_kotlin_collections_HashMapKeysDefault_bct206_k$(this);
      }
      createValuesView_4isqvv_k$() {
        return HashMapValuesDefault().new_kotlin_collections_HashMapValuesDefault_3yszgo_k$(this);
      }
      get_keys_wop4xp_k$() {
        var tmp0_elvis_lhs = this.keysView_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.createKeysView_aa1bmb_k$();
          this.keysView_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      get_values_ksazhn_k$() {
        var tmp0_elvis_lhs = this.valuesView_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.createValuesView_4isqvv_k$();
          this.valuesView_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      clear_j9egeb_k$() {
        this.get_entries_p20ztl_k$().clear_j9egeb_k$();
      }
      putAll_wgg6cj_k$(from) {
        this.checkIsMutable_jn1ih0_k$();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.get_value_j01efc_k$();
          this.put_4fpzoq_k$(key, value);
        }
      }
      remove_gppy8k_k$(key) {
        this.checkIsMutable_jn1ih0_k$();
        var iter = this.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (iter.hasNext_bitz1p_k$()) {
          var entry = iter.next_20eer_k$();
          var k = entry.get_key_18j28a_k$();
          if (equals(key, k)) {
            var value = entry.get_value_j01efc_k$();
            iter.remove_ldkf9o_k$();
            return value;
          }
        }
        return null;
      }
      checkIsMutable_jn1ih0_k$() {
      }
    }
    initMetadataForClass($, 'AbstractMutableMap', VOID, VOID, [KtMutableMap()]);
    AbstractMutableMapClass = $;
  }
  return AbstractMutableMapClass;
}
//region block: exports
export {
  AbstractMutableMap as AbstractMutableMapyktux9ubhc1g,
};
//endregion

//# sourceMappingURL=AbstractMutableMap.mjs.map
